module.exports = __webpack_public_path__ + "static/media/demo-concept.b88e05d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/demo-concept.mp4
// module id = I+b0
// module chunks = 1 2